import { Button, Card, Input, InputProps, Space } from 'antd';
import { useState } from 'react';
import { RawRangeType } from '../types';

export type RangeFilterProps = {
  from?: number;
  to?: number;
  defaultValue?: RawRangeType;
  onApplyFilter: (values: RawRangeType) => void;
};

const RangeFilterDropdown = (props: RangeFilterProps) => {
  const { from, to, defaultValue = { from: '', to: '' }, onApplyFilter } = props;
  const [values, setValues] = useState([defaultValue.from, defaultValue.to]);

  const onMinChange: InputProps['onChange'] = (event) => setValues([event.target.value, values[1]]);
  const onMaxChange: InputProps['onChange'] = (event) => setValues([values[0], event.target.value]);
  const onFilter = () => onApplyFilter({ from: values[0], to: values[1] });
  const onClear = () => setValues(['', '']);

  return (
    <Card size="small" title="Range">
      <Space align="center">
        <span>From:</span>
        <Input type="number" value={values[0]} min={from} max={to} onChange={onMinChange} className="w-16" aria-label="From" />
        <span>To:</span>
        <Input type="number" value={values[1]} min={from} max={to} onChange={onMaxChange} className="w-16" aria-label="To" />
        <Button type="primary" onClick={onFilter}>
          Filter
        </Button>
        <Button onClick={onClear}>Clear</Button>
      </Space>
    </Card>
  );
};

export default RangeFilterDropdown;
